import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import Consultations from '@services/Consultations'
import { useTranslation } from 'react-i18next'
import { history } from '@services/History'

import SignInWrapper from './signinWrapper'
import PasswordMeterField from '@modules/formFields/passwordMeterField'
import { useDispatch, useSelector } from 'react-redux'
import { selectProfile, updatePassword } from './auth.Dux'
import MDBanner from '../core/components/MD.Banner'

const ChangePassword = (props) => {
  const [oldPassword, setOldPassword] = useState(null)
  const [password, setPassword] = useState(null)
  const [passwordConfirmation, setPasswordConfirmation] = useState(null)
  const [error, setError] = useState(null)
  const { t } = useTranslation()
  const mustChangePassword = useSelector(selectProfile).must_change_password

  const dispatch = useDispatch()

  const resetPassword = async () => {
    if (!oldPassword) {
      setError('no-password')
      return
    }

    if (!password || !passwordConfirmation) {
      setError('no-password')
      return
    }
    if (password !== passwordConfirmation) {
      setError('no-passwords-match')
      return
    }
    try {
      const { data } = await Consultations.auth.passwordChange({
        old_password: oldPassword,
        new_password: password,
        new_password_confirmation: passwordConfirmation,
      })
      localStorage.setItem('jwtToken', data.access_token)
      dispatch(updatePassword(data.access_token))
      history.push('/')
    } catch (e) {
      let status = e?.response?.status || true
      setError(status)
    }
  }
  const subtitleText = !!mustChangePassword
    ? t('Dado que es la primera vez que accedes al Admin, debes cambiar tu contraseña por seguridad. ¡Gracias!')
    : t(
        'Te recordamos que por seguridad tendrás que cambiar tu contraseña cada tres meses. No te preocupes, te lo recordaremos cuando llegue el momento'
      )
  // cuando no se cumple con el regex, a password se el pasa null
  const enableButton = !!(password && password === passwordConfirmation)

  return (
    <SignInWrapper>
      <h2>{t('Cambiar la contraseña')}</h2>
      <h3>{subtitleText}</h3>
      <PasswordMeterField
        handler={(e) => setOldPassword(e)}
        placeholder={t('Contraseña Actual')}
        disableLevel={true}
        disablePanel={true}
      />
      <PasswordMeterField handler={(e) => setPassword(e)} placeholder={t('Nueva Contraseña')} />
      <PasswordMeterField
        handler={(e) => setPasswordConfirmation(e)}
        placeholder={t('Confirmación nueva contraseña')}
        disableLevel={true}
        disablePanel={true}
      />

      {error && <MDBanner message={error} onClose={() => setError(null)} error />}

      <div className="buttons-container">
        {!mustChangePassword && <button onClick={() => history.push('/admin')}>{t('BackAdmin')}</button>}
        <button disabled={!enableButton} onClick={() => resetPassword()}>
          {t('Enviar')}
        </button>
      </div>
    </SignInWrapper>
  )
}

export default withRouter(ChangePassword)
